import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'code', label: 'Code' },
  { key: 'name', label: 'Name' },
  { key: 'country', label: 'Country' },
  { key: 'currency_code', label: 'Currency' },
  { key: 'amount_local', label: 'Amount (Local)', align: 'right', type: 'money' },
  { key: 'amount_vuv', label: 'Amount (VUV)', align: 'right', type: 'money' },
  { key: 'fx_movement_percent', label: 'FX Movement', align: 'right', type: 'percent' },
  { key: 'country_concentration_percent', label: '% of Offshore Book (Country)', align: 'right', type: 'percent' },
  { key: 'concentration_flag', label: 'Status' },
];

export function OffshoreExposureReport() {
  return (
    <ReportView
      title="Offshore Exposure"
      description="Every offshore holding with country, currency, local and VUV-translated amount, FX movement since acquisition, and country concentration flagged over 25%."
      endpoint="/reports/investments/offshore-exposure"
      columns={COLUMNS}
      xlsx
    />
  );
}
